import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class AccountAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Accounts';
  controllerName = 'Accounts';

  //Đường dẫn api
  loginUrl = 'login';
  logoutUrl = 'logout';
  imageCaptchaUrl = 'ImageCaptcha';
  getAllRoleUrl = 'all';
  resetPassDefault = 'reset-password-default';
  search = 'search-misaid';
  isMisaID = 'check-account-misaid';
  nationalEmployee = 'national-employee';
  checkAssociated = 'check-has-associated-data';
  sendVerifyTwoFactor = 'verify-two-factor';
  resendCode = 'resend-two-factor';
  anotheraway = 'anotherway';
  /**
   * Đăng xuất
   */
  logout() {
    let request = {
      url: [this.getAPIUrl(), this.logoutUrl].join(''),
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy list role
   * nvchinh 26.09.2023
   * @returns
   */
  async getAllRole() {
    let request = {
      url: [window._apis['Business'] + '/Roles/' + this.getAllRoleUrl].join(''),
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy list account pagging
   * nvchinh 26.09.2023
   * @returns
   */
  async getAccountPagging(data, isShowLoading = true) {
    let request = {
      url: [window._apis['Business'] + '/Employees/list'].join(''),
      data: JSON.stringify(data),
    };

    return await httpClient.postAsync(request, isShowLoading);
  }

  /**
   * Lấy list nation
   * nvchinh 26.09.2023
   * @returns
   */
  async getAllNation() {
    let request = {
      url: [window._apis['Business'] + '/Nationals/' + this.getAllRoleUrl].join(''),
    };

    return await httpClient.getAsync(request, false);
  }

  async getAllNationalEmployee() {
    let request = {
      url: [window._apis['Business'], 'Employees', this.nationalEmployee].join('/'),
    };
    return await httpClient.getAsync(request, false);
  }

  /**
   * thêm acccount
   * @param {*} model
   * @returns
   * nvchinh 26.09.2023
   */
  async insertAccount(model) {
    let request = {
      url: [window._apis['Business'] + '/Employees'].join(''),
      data: JSON.stringify(model),
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * sửa acccount
   * @param {*} model
   * @returns
   * nvchinh 26.09.2023
   */
  async updateAccount(model) {
    let request = {
      url: [window._apis['Business'] + '/Employees'].join(''),
      data: JSON.stringify(model),
    };
    var res = await httpClient.putAsync(request);
    return res;
  }

  /**
   * Cập nhật định dạng ngày của nhân viên
   * @param {string} employeeId - ID nhân viên (Guid)
   * @param {string} dateFormat - Định dạng ngày (dd/MM/yyyy hoặc MM/dd/yyyy)
   * @returns
   */
  async updateDateFormat(employeeId, dateFormat) {
    let request = {
      url: `${window._apis['Business']}/Employees/update-date-format?employeeId=${employeeId}&dateFormat=${encodeURIComponent(dateFormat)}`,
      isShowLoading: false,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * delete acccount
   * @param {*} model
   * @returns
   * nvchinh 26.09.2023
   */
  async deleteAccount(model) {
    let request = {
      url: [window._apis['Business'] + '/Employees'].join(''),
      data: JSON.stringify(model),
    };
    var res = await httpClient.deleteAsync(request);
    return res;
  }

  /**
   * Lấy list partner
   * nvchinh 26.09.2023
   * @returns
   */
  async getAllPartner() {
    let request = {
      url: [window._apis['Business'] + '/Partners/' + this.getAllRoleUrl].join(''),
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Đăng nhập
   */
  login(model) {
    let request = {
      url: [this.getAPIUrl(), this.loginUrl].join('/'),
      data: JSON.stringify(model),
      isShowLoading: true,
    };
    var res = httpClient.postAsync(request);
    return res;
  }
  /**
   * xác thực 2fa
   */
  async sendVerifyTwoFactorFunc(model) {
    let request = {
      url: [this.getAPIUrl(), this.sendVerifyTwoFactor].join('/'),
      data: JSON.stringify(model),
      isShowLoading: true,
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   *  get token misaID
   */
  async getMisaIDToken(model) {
    let request = {
      url: [this.getAPIUrl(), 'connect/token'].join('/'),
      data: JSON.stringify(model),
      isShowLoading: true,
    };
    var res = await httpClient.postAsync(request, false);
    return res;
  }

  /** image captcha */
  imageCaptcha() {
    let request = {
      url: [this.getAPIUrl(), this.imageCaptchaUrl].join('/'),
      contenType: 'Image/jpeg',
    };
    return httpClient.postAsync(request);
  }

  /**
   *
   * @returns Lấy role từ sesion
   */
  getRoleBySession() {
    return JSON.parse(window.sessionStorage.getItem('role-license'));
  }

  getRole(role) {
    this.role = this.getRoleBySession();
    if (this.role?.RoleLevel) {
      for (var i = 0; i < this.role.RoleLevel.length; ++i) {
        if (this.role.RoleLevel[i] == role) {
          return true;
        }
      }
    }
    return false;
  }

  async resetPasswordDefault(id) {
    let request = {
      url: [window._apis['Business'], 'Employees', this.resetPassDefault, id].join('/'),
    };
    var res = await httpClient.getAsync(request);
    return res;
  }

  async searchEmployeeMisaID(text) {
    let request = {
      url: [window._apis['Business'], 'Employees', this.search].join('/'),
      params: { text },
    };
    var res = await httpClient.getAsync(request);
    return res;
  }

  async checkAccountIsMisaID(userName) {
    let request = {
      url: [window._apis['Business'], 'Employees', this.isMisaID].join('/'),
      params: { userName },
    };
    var res = await httpClient.getAsync(request, false);
    return res;
  }

  async checkHasAssociated(id) {
    let request = {
      url: [window._apis['Business'], 'Employees', this.checkAssociated, id].join('/'),
    };
    var res = await httpClient.getAsync(request, false);
    return res;
  }

  /**
   * yêu cầu lấy lại mã code
   * @param {any} model
   * @returns
   */
  async resendCodeFunc(model) {
    let request = {
      url: [this.getAPIUrl(), this.resendCode].join('/'),
      data: JSON.stringify(model),
      isShowLoading: true,
    };
    var res = httpClient.postAsync(request);
    return res;
  }
  /**
   * lấy các method có thể xác thực 2fa
   * @param {any} model
   * @returns
   */
  async anotherawayFunc(model) {
    let request = {
      url: [this.getAPIUrl(), this.anotheraway].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async sendEmail2FA(param) {
    let request = {
      url: [this.getAPIUrl(), 'send-email-2fa'].join('/'),
      data: JSON.stringify(param),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async verify2FA(param) {
    let request = {
      url: [this.getAPIUrl(), 'verify-2fa'].join('/'),
      data: JSON.stringify(param),
    };
    var res = httpClient.postAsync(request);
    return res;
  }
}

export default new AccountAPI();
